@if (isVisible$ | async) {
  @if (!closed()) {
    <div class="fixed top-1/3 right-4 z-3">
      <app-router-link [route]="Route.PL_AccountQuestionnaires">
        <div
          class="flex size-14 items-center justify-center rounded-full bg-white shadow-lg transition-all"
          pTooltip="Kliknij tutaj, aby zobaczyć ankiety dostępne do wypełnienia."
          tooltipPosition="left">
          <app-icon
            [icon]="Icon.EmojiHeartEyes"
            class="text-3xl text-(--app-primary-color) transition-all hover:scale-110" />

          <div class="absolute -bottom-2 -left-1">
            <app-counter-badge [counter$]="count$" />
          </div>
        </div>
      </app-router-link>

      <div class="absolute -top-2 -right-1">
        <p-button
          (onClick)="handleCloseClick($event)"
          severity="contrast"
          styleClass="p-0.5 text-xs"
          type="button">
          <app-icon [icon]="Icon.X_LG" />
        </p-button>
      </div>
    </div>
  }
}
